import classnames from 'classnames';
import React from 'react';
import { Input, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import { InlineTooltip } from '../tooltips';
import './styles.css';

const Label = ({
    error,
    className,
    children,
    ...props
}) => {
    return (
        <label className="label" {...props}>
            {children}
        </label>
    );
};

export const TextInputButton = ({
    type,
    id,
    label,
    textTooltip,
    error,
    value,
    onChange,
    buttonModal,
    className,
    ...props
}) => {


    const classes = classnames(
        // 'input-group',
        {
            'animated shake error': !!error,
        },
        className
    );

    let inline = '';

    if (textTooltip !== undefined) {
        inline =
            <InlineTooltip id={id} text={textTooltip} />
    }

    return (
        <div style={{ marginBottom: 10 }}>
            <Row>
                <div className='col-md-12'>
                    <div className={classes}>
                        <Label htmlFor={id} error={error}>
                            {label}
                            {inline}
                        </Label>
                    </div>
                </div>
                <div className='col-md-12'>
                    <InputGroup className={classes} style={{ marginBottom: 0 }}>
                        <Input
                            className="input-mask"
                            id={id}
                            type={type}
                            value={value}
                            onChange={onChange}
                            {...props}
                        />
                        <InputGroupAddon addonType="append">{buttonModal}</InputGroupAddon>
                    </InputGroup>
                </div>
            </Row>
            <Row>
                <div className='col-md-12'>
                    <div className={classes}>
                        <InputFeedback error={error} />
                    </div>
                </div>
            </Row>
        </div>

    );
};


const InputFeedback = ({ error }) =>
    error ?
        <div className="input-feedback" style={{ fontStyle: 'italic' }}>{error}</div> : null